import * as React from 'react';

import { mergeClassNames } from '@/lib/utils';

const TwitterIcon = ({ className, fill = 'currentColor', ...props }: React.ComponentProps<'svg'>) => (
    <svg
        width={20}
        height={20}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={mergeClassNames('w-[20px] h-[20px]', className)}
        {...props}
    >
        <g clipPath="url(#clip0_1742_13606)">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.2879 19.1673L8.66337 12.5757L2.87405 19.1673H0.424805L7.57674 11.0266L0.424805 0.833984H6.71309L11.0717 7.0465L16.5327 0.833984H18.982L12.1619 8.59772L19.5762 19.1673H13.2879ZM16.0154 17.309H14.3665L3.93176 2.69232H5.58092L9.7601 8.54495L10.4828 9.56054L16.0154 17.309Z"
                fill={fill}
            />
        </g>
        <defs>
            <clipPath id="clip0_1742_13606">
                <rect width="20" height="20" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export default TwitterIcon;